
import { t } from "i18next";
import { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faPenToSquare } from "@fortawesome/pro-solid-svg-icons";
import { ChatbotRoleLabel } from "./ChatbotRoleLabel";
import { useWebSocketContext } from "../utils/chatbotWSContext";
import { ChatbotStateContext, ChatbotStateDispatchContext } from "../utils/chatbotContext";


export const ChatbotTopCtrls = ({ isNavVisible, setIsNavVisible }: { isNavVisible: boolean, setIsNavVisible: (arg: boolean) => void }) => {

  const chatbotCurrentState = useContext(ChatbotStateContext);
  const dispatch = useContext(ChatbotStateDispatchContext);
  const { startNewConversation } = useWebSocketContext();

  const handleNewConversation = () => {
    startNewConversation(chatbotCurrentState.selectedBrand, chatbotCurrentState.selectedRole);
    dispatch({ type: "CLEAR_SELECTED_CONVERSATION" });
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center">
        <div
          tabIndex={0}
          role="button"
          title={t`Create new Wingman chat`}
          aria-label="Create new Wingman chat"
          className="pt-4 pl-4 cursor-pointer text-xl"
          onClick={() => handleNewConversation()}
          onKeyDown={(e) => e.key === "Enter" && handleNewConversation()}>
          <FontAwesomeIcon icon={faPenToSquare} aria-label="New Chat" />
        </div>
        <div
          tabIndex={0}
          role="button"
          title={t`Open Wingman Chat History`}
          aria-label="Open Wingman Chat History"
          className="pt-4 pl-4 cursor-pointer text-xl"
          onClick={() => setIsNavVisible(!isNavVisible)}
          onKeyDown={(e) => e.key === "Enter" && setIsNavVisible(!isNavVisible)}>
          <FontAwesomeIcon icon={faBars} aria-label="Toggle Chat SideNav" />
        </div>
      </div>
      {chatbotCurrentState.currentState === "Connected State" && (
        <div className="pr-4">
          <ChatbotRoleLabel></ChatbotRoleLabel>
        </div>
      )}
    </div>
  );
};